export default __webpack_public_path__ + "static/media/Pet_Painting_Price Lists_Creations_by_Jennifer_Kramer.9306a152.pdf";